import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'timeFormat',
    standalone: false
})
export class TimeFormatPipe implements PipeTransform {

  transform(duration: string | null): string {
    if (!duration) {
      return '';
    }

    // 'hh:mm:ss'
    if (duration.length == 8) {
      return duration;
    }

    const durationHasADayPattern = /^\d+\./;
    // transform 'd.hh:mm:ss' to 'hh:mm:ss'
    if (durationHasADayPattern.test(duration)) {
        const parts = duration.replace('.', ':').split(':');

        const days = parseInt(parts[0]);
        const hours = parseInt(parts[1]);
        const minutes = parseInt(parts[2]);
        const seconds = parseInt(parts[3]);

        const totalHours = days * 24 + hours;

        return `${totalHours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }
    // transform 'hh:mm:ss.ms' to 'hh:mm:ss'
    else {
         return duration.split('.')[0];
    }
  }

}
